import { IconWrapper } from './IconWrapper'
import { IIconProps } from './props'

export function WalletIcon(props: IIconProps) {
  return (
    <IconWrapper {...props}>
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M26.2353 11.9751V9.03106C26.2353 7.59733 26.2353 6.88046 25.9563 6.33285C25.7109 5.85115 25.3192 5.45952 24.8375 5.21408C24.2899 4.93506 23.573 4.93506 22.1393 4.93506H7.29131C5.85758 4.93506 5.14071 4.93506 4.5931 5.21408C4.1114 5.45952 3.71977 5.85115 3.47434 6.33284C3.19531 6.88046 3.19531 7.59732 3.19531 9.03106V21.3191C3.19531 22.7528 3.19531 23.4697 3.47434 24.0173C3.71977 24.499 4.1114 24.8906 4.5931 25.136C5.14071 25.4151 5.85758 25.4151 7.29131 25.4151L22.1393 25.4151C23.573 25.4151 24.2899 25.4151 24.8375 25.136C25.3192 24.8906 25.7109 24.499 25.9563 24.0173C26.2353 23.4697 26.2353 22.7528 26.2353 21.3191V18.3751M19.8353 15.1751C19.8353 14.5803 19.8353 14.2829 19.8845 14.0356C20.0865 13.0201 20.8804 12.2263 21.8959 12.0242C22.1432 11.9751 22.4406 11.9751 23.0353 11.9751H25.5953C26.1901 11.9751 26.4875 11.9751 26.7347 12.0242C27.7503 12.2263 28.5441 13.0201 28.7461 14.0356C28.7953 14.2829 28.7953 14.5803 28.7953 15.1751C28.7953 15.7698 28.7953 16.0672 28.7461 16.3145C28.5441 17.33 27.7503 18.1239 26.7347 18.3259C26.4875 18.3751 26.1901 18.3751 25.5953 18.3751H23.0353C22.4406 18.3751 22.1432 18.3751 21.8959 18.3259C20.8804 18.1239 20.0865 17.33 19.8845 16.3145C19.8353 16.0672 19.8353 15.7698 19.8353 15.1751Z"
          stroke="currentColor"
          strokeWidth="2.475"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconWrapper>
  )
}
